<template>
  <!-- Mobile -->
  <div class="options hidden-xs-up">
    <a
      class="delete-product"
      :title="$t('Remove from cart')"
      @click="deleteProduct(product)"
    >
      <img
        :src="url('/img/icons/cancel.svg')"
        alt="Odstrániť produkt"
      >
    </a>
    <a
      :href="editProduct(product, index)"
      class="edit-product"
      :title="$t('Edit product')"
    >
      <img
        :src="url('/img/icons/edit.svg')"
        alt="Editovať produkt"
      >
    </a>
  </div>
  <div
    class="photo"
    :style="{ backgroundImage: `url(${getImage(product)})` }"
  />
  <div class="text">
    <h2>{{ product.name }}</h2>
    <p
      v-for="(attributeValue, attributeName) in product.attribute_values"
      v-if="!empty(product.attribute_values)"
    >
      <strong>{{ $t(capitalize(attributeName)) }}:</strong>
       {{ $t(attributeValue.slug) }}
    </p>
    <!-- Horizontal -->
    <p v-if="product.attributes.hasOwnProperty('isHorizontal')">
      <strong>{{ $t("Horizontal rotation") }}:</strong>
       {{ product.attributes.isHorizontal ? $t("Yes") : $t("No") }}
    </p>
    <!-- Fullwidth -->
    <p v-if="product.attributes.hasOwnProperty('isFullwidth')">
      <strong>{{ $t("Fullwidth image") }}:</strong>
       {{ product.attributes.isFullwidth ? $t("Yes") : $t("No") }}
    </p>
    <!-- Stand text -->
    <p v-if="product.attributes.hasOwnProperty('standText')">
      <strong>{{ $t("Stand text") }}:</strong>
       {{ product.attributes.standText }}
    </p>
    <!-- Packaging text -->
    <p v-if="product.attributes.hasOwnProperty('packagingText')">
      <strong>{{ $t("Packaging text") }}:</strong>
       {{ product.attributes.packagingText }}
    </p>
    <!-- Lovers -->
    <p v-if="product.attributes.hasOwnProperty('names')">
      <strong>{{ $t("Names") }}:</strong>
       {{ product.attributes.names }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('date')">
      <strong>{{ $t("Date") }}:</strong>
       {{ product.attributes.date }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('place')">
      <strong>{{ $t("Place") }}:</strong>
       {{ product.attributes.place }}
    </p>
    <!-- Custom -->
    <p v-if="product.attributes.hasOwnProperty('primaryText')">
      <strong>{{ $t("Primary text") }}:</strong>
       {{ product.attributes.primaryText }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('secondaryText')">
      <strong>{{ $t("Secondary text") }}:</strong>
       {{ product.attributes.secondaryText }}
    </p>
    <!-- Music -->
    <p v-if="product.attributes.hasOwnProperty('song')">
      <strong>{{ $t("Song name") }}:</strong>
       {{ product.attributes.song }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('interpret')">
      <strong>{{ $t("Interpret") }}:</strong>
       {{ product.attributes.interpret }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('actualTime')">
      <strong>{{ $t("Actual time") }}:</strong>
       {{ product.attributes.actualTime }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('endTime')">
      <strong>{{ $t("End time") }}:</strong>
       {{ product.attributes.endTime }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('qr')">
      <strong>{{ $t("QR link") }}:</strong>
       {{ product.attributes.qr }}
    </p>
    <!-- Instagram -->
    <p v-if="product.attributes.hasOwnProperty('accountName')">
      <strong>{{ $t("Account name") }}:</strong>
       {{ product.attributes.accountName }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('description')">
      <strong>{{ $t("Description") }}:</strong>
       {{ product.attributes.description }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('like')">
      <strong>{{ $t("Like it") }}:</strong>
       {{ product.attributes.like }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('others')">
      <strong>{{ $t("And others") }}:</strong>
       {{ product.attributes.others }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('approvedAccount')">
      <strong>{{ $t("Approved account") }}:</strong>
       {{ product.attributes.approvedAccount ? $t("Yes") : $t("No") }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('likedPhoto')">
      <strong>{{ $t("Liked photo") }}:</strong>
       {{ product.attributes.likedPhoto ? $t("Yes") : $t("No") }}
    </p>
    <p v-if="product.attributes.hasOwnProperty('activeStories')">
      <strong>{{ $t("Active stories") }}:</strong>
       {{ product.attributes.activeStories ? $t("Yes") : $t("No") }}
    </p>
    <!-- Image -->
    <p v-if="product.files.originalFile">
      <strong>{{ $t("Image") }}:&nbsp;</strong>
      <a
        v-if="product.files.hasOwnProperty('croppedFile')"
        :href="product.files.croppedFile.url"
        target="_blank"
      >
        {{ $t("Uploaded image") }}
      </a>
      <a
        v-else-if="product.files.hasOwnProperty('originalFile')"
        :href="product.files.originalFile.url"
        target="_blank"
      >
        {{ $t("Uploaded image") }}
      </a>
    </p>
    <!-- Insta - profile image -->
    <p v-if="product.category_id === 2">
      <strong>{{ $t("Profile") }}:&nbsp;</strong>
      <a
        v-if="product.files.hasOwnProperty('croppedProfile')"
        :href="product.files.croppedProfile.url"
        target="_blank"
      >
        {{ $t("Uploaded profile image") }}
      </a>
    </p>
    <!-- Photo - collage -->
    <p v-if="product.category_id === 5">
      <strong>{{ $t("Images") }}:&nbsp;</strong>
      <template v-for="index in layoutPhotoCount(product)">
        <a
          v-if="product.files.hasOwnProperty(`croppedCollage${index}`)"
          :href="product.files[`croppedCollage${index}`].url"
          target="_blank"
        >
          {{ $t("Image") }} {{ index }}
        </a>
        <span v-if="index < layoutPhotoCount(product)">, </span>
      </template>
    </p>
    <div class="row">
      <ProductServices :product="product" />
    </div>
    <div class="options">
      <a
        class="delete-product hidden-xs-down"
        :title="$t('Remove from cart')"
        @click="deleteProduct(product)"
      >
        <img
          :src="url('/img/icons/cancel.svg')"
          alt="Odstrániť produkt"
        >
      </a>
      <a
        :href="editProduct(product, index)"
        class="edit-product hidden-xs-down"
        :title="$t('Edit product')"
      >
        <img
          :src="url('/img/icons/edit.svg')"
          alt="Editovať produkt"
        >
      </a>
      <div class="qty">
        <span
          class="handler"
          @click="incrementProduct(product)"
        >+</span>
        <span class="counter">{{ product.qty }}</span>
        <span
          class="handler"
          @click="decrementProduct(product)"
        >-</span>
      </div>
      <p class="price">
        {{ productPrice }}
      </p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { computed } from '@vue/reactivity'
import { empty, capitalize, optional } from '../../../../../helpers'
import useCart from '../../useCart'
import useGlobal from '../../../../useGlobal'
import ProductServices from '../../../../packages/views/product-service/Services'
import useProduct from '../../../product/useProduct'
import useRoutes from '../../../../useRoutes'
import useDiscountCoupon from '../../../../packages/views/discount-coupon/useDiscountCoupon'

export default {
  components: {
    ProductServices,
  },
  props: {
    product: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  methods: {
    ...mapMutations('cart', ['INCREMENT_PRODUCT_QTY', 'DECREMENT_PRODUCT_QTY']),
    incrementProduct(product) {
      this.INCREMENT_PRODUCT_QTY(product)

      this.applySpecialDiscount()
    },
    decrementProduct(product) {
      this.DECREMENT_PRODUCT_QTY(product)

      this.applySpecialDiscount()
    },
  },
  setup(props) {
    const { deleteProduct, getImage, layoutPhotoCount } = useCart()
    const { getTotalProductPrice } = useProduct()
    const { applySpecialDiscount } = useDiscountCoupon()
    const { url } = useGlobal()
    const { editProduct } = useRoutes()
    const productPrice = computed(() => getTotalProductPrice(props.product))

    return {
      productPrice,
      getImage,
      url,
      deleteProduct,
      empty,
      capitalize,
      optional,
      layoutPhotoCount,
      editProduct,
      applySpecialDiscount,
    }
  },
}
</script>
